import React from 'react';

const SelectStatus = ({ value, onChange, inputStyles, options }) => {
    return (
        <div className="mt-2">
            <select
                value={value}
                onChange={onChange}
                style={inputStyles}
                id="customer"
                name="customer"
                autoComplete="customer"
                required
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
                <option value="" disabled>Select</option>
                {/* Map through the options and create <option> elements */}
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SelectStatus;
